import { Box, CircularProgress, Grid } from '@mui/material';
import React from 'react';
import styles from './GridMode.module.scss';
import GridItem from './GridItem';

const GridMode = ({ users, onScroll, loading }) => (
  <Grid
    onScroll={onScroll}
    className={styles.gridContent}
    alignItems="stretch"
    container
    spacing={2}
    columns={{ xl: 15, md: 15, sm: 12, xs: 12 }}
  >
    {users && users.map((user) => <GridItem user={user} />)}
    {loading && (
      <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center', my: 2 }}>
        <CircularProgress
          sx={{
            width: '40px !important',
            height: '40px !important',
          }}
        />
      </Box>
    )}
  </Grid>
);

export default GridMode;
